import { TextInputProps } from "react-native"
import Input from ".."
export default (input: Input): TextInputProps => {
    return {
        ...input.props,
        secureTextEntry: false,
        autoCapitalize: "none",
    }
}